import { CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { Customer, CustomerDTO } from './customer.interface';

export class CustomerService {
   async getCustomers(query?: LocationQuery): Promise<PaginatedResponse<Customer>> {
      const response = await http.get<PaginatedResponse<Customer>>(`/customers`, { params: { ...query } });
      return response.data;
   }

   async getCustomer(customerId: number, query?: LocationQuery, config?: CustomAxiosRequestConfig): Promise<Customer> {
      const response = await http.get<ApiResource<Customer>>(`/customers/${customerId}`, {
         params: { ...query },
         cancelable: config?.cancelable,
      } as CustomAxiosRequestConfig);
      return response.data.data;
   }

   async postCustomer(customer: CustomerDTO): Promise<Customer> {
      const response = await http.post<Customer>(`/customers`, customer, { params: { append: 'scopes' } });
      return response.data;
   }

   async putCustomer(customerId: number, customer: CustomerDTO): Promise<Customer> {
      const response = await http.put<Customer>(`/customers/${customerId}`, customer, { params: { append: 'scopes' } });
      return response.data;
   }

   async deleteCustomer(customerId: number): Promise<void> {
      const response = await http.delete(`/customers/${customerId}`);
      return response.data;
   }
}
